<template>
  <tr :class="['schedule-line', `${ClockInTableRecord.statusColor(clockIn.status)}`]">
    <template v-if="tutor">
      <td class="tutor-name-box">
        <router-link :to="{name: 'TimesheetDetail', params: { tutorId: tutor.id }}">
          {{ tutor.name | cutName }}
        </router-link>
        <div class="d-flex">
          <div class="tutor-number">{{ tutor.id }}</div>
        </div>
      </td>
      <td>
        <router-link
          :to="{
            name: 'ClockInDetail',
            params: { tutorId: tutor.id, date: date.format('YYYYMMDD') },
          }"
        >
          <template v-if="clockIn.stamp">
            {{ clockIn.stamp.format('HH:mm') }}
          </template>
          <template v-else>
            Not Clocked In
          </template>
        </router-link>
      </td>
    </template>
    <template v-else>
      <td class="not-assigned">
        <p>
          Not assigned lessons
        </p>
      </td>
      <td class="not-assigned"></td>
    </template>
    <td colspan="7" class="period-box">
      <div class="period-box-container">
        <div class="period-box-border"/>
        <div class="period-box-border"/>
        <div class="period-box-border"/>
        <div class="period-box-border"/>
        <div class="period-box-border"/>
        <div class="period-box-border"/>
        <div class="period-box-border"/>
      </div>
      <router-link
        v-for="schedule of clockIn.schedules"
        :key="schedule.scheduleId"
        :style="ClockInTableRecord.scheduleStyle(schedule.startPeriod, schedule.endPeriod)"
        :class="[ 'mark', `${schedule.type}` ]"
        :to="{
          name: schedule.type === 'lesson' || schedule.type === 'subLesson'
            ? 'LessonDetails'
            : 'EditSchedule',
          params: {
            lessonId: schedule.scheduleId,
            tutorId: clockIn.tutor && clockIn.tutor.id,
            scheduleId: schedule.scheduleId,
          }
        }"
      >
        <div v-if="schedule"
        v-b-popover.hover="schedule.boothBuilding.building + ', ' +
        schedule.boothRoom.room + ', ' + schedule.boothNumber.number">
          {{ schedule.level && schedule.level.code }}
        </div>
        <div class="campusname-box" v-if="schedule.participationTime">
          {{ schedule.participationTime }}m
        </div>
      </router-link>
    </td>
  </tr>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import _ from 'lodash'
import { Moment } from 'moment'
import { periodType } from '@/store/common.types'
import { ClockIn, clockInStatus } from '@/store/clockIn/types'

@Component({
  filters: {
    // tutorNameの長さで省略
    cutName(tutorName: string) {
      if (tutorName.length > 30) {
        return `${tutorName.slice(0, 30)}…`
      }
      return tutorName
    },
  },
})
export default class ClockInTableRecord extends Vue {
  @Prop() date!: Moment

  @Prop() clockIn!: ClockIn

  private ClockInTableRecord: any = ClockInTableRecord

  private get tutor() {
    return this.clockIn.tutor
  }

  /**
   * 勤怠状況によって色を取得
   * @param {string} status ステータス
   * @returns {string} 色
   */
  private static statusColor(status: clockInStatus): string {
    switch (status) {
      case '遅刻': return 'red'
      case '出勤済み': return 'blue'
      case '欠勤': return 'gray'
      case '未アサイン': return 'yellow'
      case '未レッスン': return 'orange'
      case '未打刻': return 'white'
      default: return ''
    }
  }

  private static scheduleStyle(startPeriod: periodType, endPeriod: periodType) {
    const diffPeriod = endPeriod - startPeriod

    if (!startPeriod && !endPeriod) {
      return {
        width: '590px',
        left: '5px',
      }
    }

    return {
      width: `${100 * diffPeriod + 90}px`,
      left: `${(startPeriod - 1) * 100 + 5}px`,
    }
  }
}
</script>

<style scoped>
.d-flex {
  display:flex;
}

th.period {
  padding: 5px 0;
  width: 100px;
  background: #B3C6E7;
  border: 1px solid #B3C6E7;
}

.date, .day {
  width: 35px;
}

.time-sheet-table td.period-box {
  position: relative;
  height: 40px;
  padding:0px;
}

.time-sheet-table td.period-box .period-box-container {
  display: flex;
  height:100%;
}

.time-sheet-table td {
  padding: 5px 0;
  border: 1px solid #B5B5B5;
  text-align: center;
}

.time-sheet-table td.period-box .period-box-border {
  display: block;
  width: 100px;
  border-right:1px solid #B5B5B5;
}

.time-sheet-table td.period-box .period-box-border:last-child {
  border-right: none;
}

.mark {
  height:30px;
  position: absolute;
  top:0px;
  bottom:0px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  border-radius: 30px;
  font-size:12px;
}

.campusname-box {
  position: absolute;
  background: #ffffff;
  color:#000;
  right:2px;
  font-size: 10px;
  padding:3px;
  border:#2E75B5 2px solid;
  border-radius: 30px;
}

.mark.lesson {
  background: #DDEAF6;
  border:2px solid #DDEAF6;
}

.mark.waiting {
  background: #87A4D9;
  border:2px solid #87A4D9;
}

.mark.subLesson {
  background: #F7CAAC;
  border:2px solid #F7CAAC;
}

.mark.workshopOrTutorTraining {
  background: #C39BE1;
  border:2px solid #C39BE1;
}

.mark.meeting {
  background: #F38181;
  border:2px solid #F38181;
}

.mark.workOnHoliday {
  background: #55A8FD;
  border:2px solid #55A8FD;
}

.mark.lessonOnHolliday {
  background: #0070C0;
  border:2px solid #0070C0;
}

.mark.absent {
  background: #A5A5A5;
  border:2px solid #A5A5A5;
}

.note {
  text-align: left;
  margin-left:10px;
}

.title-period , .title-tutor-name {
  background: #ededed;
  border-bottom: 2px solid #fff;
}

th.title-period:hover {
  background: #c6c6c6;
}

.title-tutor-name {
  border-right: 2px solid #fff;
}

.title-note {
  background: #ededed;
  border-left: 2px solid #fff;
}

.tutor-name-box .d-flex {
  justify-content: flex-end;
}

.schedule-line .tutor-name-box .tutor-number {
  padding:1px 10px;
  background: #E9F0F7;
  color: #000;
  border-radius: 30px;
  margin-right: 5px;
}

.schedule-line.red {
  background: #F06262;
  color: #fff;
}

.schedule-line.blue {
  background: #BBD6EE;
}

.schedule-line.gray {
  background: #D8D8D8;
}

.schedule-line.yellow {
  background: #ffffb3;
}

.schedule-line.white {
  background: #FFFFFF;
}

.schedule-line.orange {
  background: #ffd9b3;
}

.asc::after {
  margin-left:5px;
  content: "▼";
}
.desc::after {
  margin-left:5px;
  content: "▲";
}

</style>
